export const AUTH = "AUTH";
export const LOGOUT = "LOGOUT";
export const SIGNIN = "SIGNIN";
export const SIGNUP = "SIGNUP";
export const GET_USER_BY_ID = "GET_USER_BY_ID";
export const SAVE_COMPANY_DATA = "SAVE_COMPANY_DATA";
export const GATE_COMPANY_BY_MANAGER_ID = "GATE_COMPANY_BY_MANAGER_ID";
export const GET_ALL_QUESTIONS = "GET_ALL_QUESTIONS";
export const SUBMIT_ANSWER = "SUBMIT_ANSWER";
export const GET_ALL_SERVEY = "GET_ALL_SERVEY";
export const ADD_SERVEY = "ADD_SERVEY";
export const DELETE_SERVEY = "DELETE_SERVEY";
export const ADD_QUESTION = "ADD_QUESTION";
export const GET_PREVIEW_PARAMS = "GET_PREVIEW_PARAMS";
export const GET_PREVIEW_DATA = "GET_PREVIEW_DATA";
export const GET_QUESTION_BY_SURVEY_ID = "GET_QUESTION_BY_SURVEY_ID";
export const DELETE_QUESTION_BY_ID = "DELETE_QUESTION_BY_ID";
export const UPDATE_QUESTION = "UPDATE_QUESTION";

// get full servey for client
export const GET_FULL_SURVEY = "GET_FULL_SURVEY";
export const UPDATE_PROFILE = "UPDATE_PROFILE";
export const UPDATE_COMPANY = "UPDATE_COMPANY";
export const CHANGE_PASSWORD = "CHANGE_PASSWORD";
export const GET_ALL_FEEDBACK = "GET_ALL_FEEDBACK";
export const GET_STAT_DATA = "GET_STAT_DATA";
export const GET_FEEDBACK_DETAIL = "GET_FEEDBACK_DETAIL";
export const GET_RECENT_FEEDBACK = "GET_RECENT_FEEDBACK";
export const PUBLISH_SURVEY = "PUBLISH_SURVEY";
export const CLEAR_DATA = "CLEAR_DATA";
export const CHECK_SECRETE_PHRASE = "CHECK_SECRETE_PHRASE";
export const EMAIL_CONFIRMATION = "EMAIL_CONFIRMATION";

export const SORT_QUESTION = "SORT_QUESTION";
export const THEME = "THEME";
